module.exports = __webpack_public_path__ + "img/main-location-icon2.8b6929eb.svg";